module.exports = __webpack_public_path__ + "static/media/mem2.d700fee8.jpg";